import axios from "axios";

export const API = "/api";

const client = axios.create({ baseURL: `${API}/radio`, timeout: 20000 });

export const searchStations = (params) =>
  client.get("/stations/search", { params }).then((r) => r.data);

export const topStations = (limit = 24) =>
  client.get("/stations/top", { params: { limit } }).then((r) => r.data);

export const trendingStations = (limit = 24) =>
  client.get("/stations/trending", { params: { limit } }).then((r) => r.data);

export const getCountries = () => client.get("/countries").then((r) => r.data);
export const getTags = (limit = 60) =>
  client.get("/tags", { params: { limit } }).then((r) => r.data);
export const getLanguages = (limit = 60) =>
  client.get("/languages", { params: { limit } }).then((r) => r.data);

export const getLanguagesByCountry = ({ country, countrycode }) =>
  client.get("/languages/bycountry", { params: { country, countrycode } }).then((r) => r.data);

export const getUserCountry = () =>
  client.get("/userCountry").then((r) => r.data).catch(() => ({ countryCode: null, countryName: null }));

export const registerClick = (uuid) =>
  client.post(`/click/${uuid}`).catch(() => null);

export const stationByUuid = (uuid) =>
  client.get(`/stations/byuuid/${uuid}`).then((r) => r.data).catch(() => null);

export const nowPlaying = (url) =>
  client
    .get("/nowplaying", { params: { url }, timeout: 10000 })
    .then((r) => r.data.title)
    .catch(() => null);

export const blockStation = (uuid) =>
  client.post(`/block/${uuid}`).catch(() => null);
export const getStationsByCountryCode = (countrycode, params = {}) =>
  client.get(`/stations/bycountrycode/${encodeURIComponent(countrycode)}`, { params }).then((r) => r.data);

